/* "Load more" for collection product grids.
   Fetches the next paginated page and appends its products to the current
   grid. Uses event delegation so the control keeps working after facets.js
   re-renders the grid container.

   Two grid flavors are supported:
   - The standard grid: #product-grid <li> items are appended directly.
   - The grouped Bargain Bin grid (#product-grid[data-grouped-grid]):
     fetched groups are merged into existing groups by denomination, and
     items are inserted in year order via their data-year attributes. */

(function () {
  var ANIMATION_CLASSES = ['scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen'];

  // Appended items never get picked up by the page-load animation
  // observer, so remove the animation hooks and show them immediately.
  function stripAnimation(item) {
    ANIMATION_CLASSES.forEach(function (className) {
      item.classList.remove(className);
    });
    item.removeAttribute('data-cascade');
    item.querySelectorAll('.scroll-trigger').forEach(function (child) {
      ANIMATION_CLASSES.forEach(function (className) {
        child.classList.remove(className);
      });
    });
  }

  function itemYear(item) {
    var year = parseInt(item.getAttribute('data-year'), 10);
    return isNaN(year) ? 9999 : year;
  }

  function groupOrder(group) {
    var order = parseInt(group.getAttribute('data-group-order'), 10);
    return isNaN(order) ? 999 : order;
  }

  function insertItemByYear(list, item) {
    var year = itemYear(item);
    var before = null;
    var existing = list.querySelectorAll(':scope > li');
    for (var i = 0; i < existing.length; i++) {
      if (itemYear(existing[i]) > year) {
        before = existing[i];
        break;
      }
    }
    list.insertBefore(item, before);
  }

  function mergeGroups(currentGrid, newGrid) {
    newGrid.querySelectorAll(':scope > [data-group]').forEach(function (newGroup) {
      var key = newGroup.getAttribute('data-group');
      var existingGroup = null;
      currentGrid.querySelectorAll(':scope > [data-group]').forEach(function (group) {
        if (!existingGroup && group.getAttribute('data-group') === key) existingGroup = group;
      });

      if (!existingGroup) {
        var order = groupOrder(newGroup);
        var before = null;
        var groups = currentGrid.querySelectorAll(':scope > [data-group]');
        for (var i = 0; i < groups.length; i++) {
          if (groupOrder(groups[i]) > order) {
            before = groups[i];
            break;
          }
        }
        newGroup.querySelectorAll('li').forEach(stripAnimation);
        currentGrid.insertBefore(newGroup, before);
        return;
      }

      var list = existingGroup.querySelector('ul');
      newGroup.querySelectorAll(':scope ul > li').forEach(function (item) {
        stripAnimation(item);
        insertItemByYear(list, item);
      });
    });
  }

  function appendItems(currentGrid, newGrid) {
    newGrid.querySelectorAll(':scope > .grid__item').forEach(function (item) {
      stripAnimation(item);
      currentGrid.appendChild(item);
    });
  }

  // On grouped grids (Bargain Bin), automatically load every remaining
  // page so all denomination groups are complete on arrival. Capped so a
  // huge collection can't fetch forever; past the cap the button remains
  // for manual loading.
  var AUTO_LOAD_MAX_PAGES = 12;
  var autoLoadedPages = 0;
  var LOADING_CLASS = 'bargain-bin-loading';

  // While auto-loading, the page shows a "Loading the latest Bargain Bin
  // items" note in place of the collection description, and the grid is
  // dimmed; both revert once every page has been merged.
  function maybeAutoLoad() {
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.hasAttribute('data-grouped-grid')) return;
    var button = document.querySelector('[data-load-more-btn]');
    if (!button || autoLoadedPages >= AUTO_LOAD_MAX_PAGES) {
      document.documentElement.classList.remove(LOADING_CLASS);
      restoreReturnPosition();
      return;
    }
    if (button.classList.contains('loading')) return;
    document.documentElement.classList.add(LOADING_CLASS);
    autoLoadedPages++;
    button.click();
  }

  // Coming back from a product page: the browser restores scroll by pixel
  // distance, which is wrong until every batch has merged in. Instead,
  // remember which product card was clicked and scroll back to it once
  // the grid is complete.
  var RETURN_KEY = 'coinGroupsReturnTo';
  var returnRestored = false;

  document.addEventListener('click', function (event) {
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.hasAttribute('data-grouped-grid')) return;
    var link = event.target.closest('a[href*="/products/"]');
    if (!link || !grid.contains(link)) return;
    try {
      sessionStorage.setItem(RETURN_KEY, link.pathname);
    } catch (error) {
      /* private browsing: fall back to default behavior */
    }
  });

  function restoreReturnPosition() {
    if (returnRestored) return;
    returnRestored = true;
    var path = null;
    try {
      path = sessionStorage.getItem(RETURN_KEY);
      sessionStorage.removeItem(RETURN_KEY);
    } catch (error) {
      return;
    }
    if (!path) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var links = grid.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].pathname === path) {
        var item = links[i].closest('li') || links[i];
        item.scrollIntoView({ block: 'center' });
        item.classList.add('coin-return-highlight');
        setTimeout(function () {
          item.classList.remove('coin-return-highlight');
        }, 2200);
        return;
      }
    }
  }

  // A back-forward-cache restore brings the page back exactly as it was,
  // scroll included — drop the stored target so it isn't reused later.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    returnRestored = true;
    try {
      sessionStorage.removeItem(RETURN_KEY);
    } catch (error) {
      /* ignore */
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.getElementById('product-grid');
    if (grid && grid.hasAttribute('data-grouped-grid')) {
      var hasReturnTarget = false;
      try {
        hasReturnTarget = !!sessionStorage.getItem(RETURN_KEY);
      } catch (error) {
        /* ignore */
      }
      if (hasReturnTarget && 'scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
    }
    maybeAutoLoad();
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-load-more-btn]');
    if (!button) return;
    event.preventDefault();
    if (button.classList.contains('loading')) return;

    button.classList.add('loading');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    var wrapper = button.closest('[data-load-more]');

    fetch(button.href)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var currentGrid = document.getElementById('product-grid');
        if (!newGrid || !currentGrid) {
          window.location.href = button.href;
          return;
        }

        if (currentGrid.hasAttribute('data-grouped-grid')) {
          mergeGroups(currentGrid, newGrid);
        } else {
          appendItems(currentGrid, newGrid);
        }

        // Keep the address bar in sync so reload/back returns near here.
        // Grouped grids must NOT do this: they auto-load every page, and
        // returning to a ?page=N URL would strand the earlier pages.
        if (!currentGrid.hasAttribute('data-grouped-grid')) {
          window.history.replaceState({}, '', button.href);
        }

        var newWrapper = doc.querySelector('[data-load-more]');
        if (newWrapper && wrapper) {
          wrapper.replaceWith(newWrapper);
        } else if (wrapper) {
          wrapper.remove();
        }

        // Grouped grids keep fetching until every page is merged, so the
        // denomination groups are complete without any clicks.
        setTimeout(maybeAutoLoad, 0);
      })
      .catch(function () {
        // Fall back to normal navigation if the fetch fails.
        window.location.href = button.href;
      });
  });
})();
